/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import _ from '@/underscore'
import ActionDropdownView from '@/io.ox/backbone/views/action-dropdown'
import ContextMenuUtils from '@/io.ox/backbone/mini-views/contextmenu-utils'
import manifests from '@/io.ox/core/manifests'

import gt from 'gettext'

function renderItems () {
  // load relevant code on demand
  return manifests.manager.loadPluginsFor(this.contextMenuRef).then(() => {
    this.contextMenu.on('ready', () => {
      if (!this.contextMenu.hasActions()) return
      this.contextMenu.$toggle.dropdown('toggle')
      // Keyboardsupport for cursor up/down on toggle
      this.contextMenu.$toggle.on('keydown', (event) => {
        if (!/^(38|40)$/.test(event.which)) return
        this.contextMenu.$menu.find('li:' + (event.which === 38 ? 'last' : 'first') + ' a').focus()
      })
      if (this.isKeyboardEvent) this.contextMenu.$menu.find('li:first a').focus()
    })

    const selection = this.selection.get()
    this.contextMenu.setSelection(selection.map(_.cid), this.getContextMenuData.bind(this, selection))
  })
}

const Contextmenu = {

  onContextMenu (e) {
    // clicks bubbles. right-click not
    // DO NOT ADD e.preventDefault() HERE (see bug 42409)
    e.stopPropagation()
    this.isKeyboardEvent = e.isKeyboardEvent
    this.clickedInFreeSpace = ContextMenuUtils.checkEventTargetOutsideList(e)
    this.toggleContextMenu(ContextMenuUtils.positionForEvent(e), e)
  },

  toggleContextMenu (pos) {
    if (_.device('smartphone')) return
    if (this.contextMenu && this.contextMenu.$el.hasClass('open')) return
    this.contextMenuRef = this.contextMenuRef || (this.ref + '/contextmenu')

    let currentRef = this.contextMenuRef
    // handle context menu in free space, when defined
    if (this.freeSpaceContextMenuRef) {
      if (this.clickedInFreeSpace) {
        // deselect when clicked in free space
        this.selection.clear()
        currentRef = this.freeSpaceContextMenuRef
      }

      if (this.contextMenu) {
        this.contextMenu.updatePoint(currentRef)
      }
    }

    this.renderContextMenu(currentRef)

    this.contextMenu.$menu.data({ top: pos.top, left: pos.left })
    return renderItems.call(this)
  },

  renderContextMenu (contextMenuRef) {
    if (this.contextMenu) return
    this.contextMenu = new ActionDropdownView({ point: contextMenuRef, title: gt('Folder options'), backdrop: true })
    this.contextMenu.$el.addClass('context-dropdown').insertAfter(this.$el)
  },

  getContextMenuData (selection) {
    return { data: selection.map(_.cid) }
  }
}

export default Contextmenu
